import { css } from "@emotion/css";
import { AriaLabelingProps } from "@react-types/shared";

interface Props {
  labelProps: AriaLabelingProps & { label?: React.ReactNode };
}

export function AccessibilityWarnings({ labelProps }: Props) {
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  if (labelProps) {
    if (
      !labelProps.label &&
      !labelProps["aria-label"] &&
      !labelProps["aria-labelledby"]
    ) {
      return (
        <div className={css({ fontFamily: "monospace", color: "red" })}>
          DEVELOPER WARNING: This input has been rendered without a label,
          aria-label or aria-labelledby.
        </div>
      );
    }
  }

  return null;
}
